import React from 'react';

export type LoaderSize = 'small' | 'medium' | 'large';

export function Loader({ size = 'medium' }: { size?: LoaderSize }) {
  return (
    <div className={`spinner ${size}`} data-testid="loader">
      <div className="spinner-wrapper">
        <div className="rotator">
          <div className="inner-spin"></div>
          <div className="inner-spin"></div>
        </div>
      </div>
    </div>
  );
}
